'use strict';

var React = require('react');
var withStyles = require('../../../node_modules/@material-ui/core/styles/withStyles.js');
var Grid = require('../../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    headerBackground: {
      background: theme.palette.background.main
    }
  };
};

var LineItemHeaderMobile = function LineItemHeaderMobile(props) {
  var classes = props.classes,
      isMaterialItems = props.isMaterialItems;
  return React__default["default"].createElement(Grid, {
    container: true,
    item: true,
    className: classes.headerBackground
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography, {
    variant: 'subtitle2',
    align: 'left'
  }, isMaterialItems ? 'Materials' : 'Services')));
};

var LineItemHeaderMobile$1 = withStyles(styles)(LineItemHeaderMobile);

module.exports = LineItemHeaderMobile$1;
